var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckedCheckBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_13477)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 7,
    width: 22,
    height: 22,
    rx: 2,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 20,
    height: 20,
    rx: 1,
    stroke: "url(#paint0_linear_106_13477)",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59861 11.7594C8.10655 11.7608 7.62495 11.9014 7.2095 12.1651C6.79406 12.4288 6.46176 12.8047 6.25104 13.2493C6.04032 13.694 5.9598 14.1892 6.0188 14.6777C6.07779 15.1662 6.27389 15.628 6.5844 16.0097L13.2038 24.1184C13.4398 24.4115 13.7423 24.644 14.0862 24.7967C14.4301 24.9493 14.8055 25.0177 15.1812 24.9962C15.9846 24.953 16.71 24.5232 17.1725 23.8166L30.9226 1.67204C30.9248 1.66837 30.9272 1.6647 30.9296 1.66108C31.0586 1.46299 31.0168 1.07042 30.7505 0.823802C30.6773 0.756078 30.5911 0.704048 30.497 0.670915C30.403 0.637781 30.3032 0.624247 30.2038 0.631145C30.1043 0.638043 30.0073 0.665228 29.9188 0.711025C29.8302 0.756822 29.752 0.820261 29.6889 0.897436C29.684 0.903504 29.6789 0.90948 29.6737 0.915365L15.8065 16.5832C15.7537 16.6428 15.6896 16.6913 15.618 16.726C15.5463 16.7606 15.4684 16.7807 15.3889 16.785C15.3094 16.7893 15.2298 16.7778 15.1548 16.751C15.0798 16.7243 15.0109 16.683 14.952 16.6294L10.3498 12.4413C9.87177 12.0032 9.24703 11.7599 8.59861 11.7594Z",
    fill: "#6F0100"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_13477",
    x: 0,
    y: 4,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.53 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_13477"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_13477",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_13477",
    x1: 10.9602,
    y1: 0.643684,
    x2: 16.1007,
    y2: 1.03638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#924E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF7B01"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckBox);
export default __webpack_public_path__ + "static/media/checkedCheckBox.77944214d327b5bc61358108b856626f.svg";
export { ForwardRef as ReactComponent };